/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_A1Inputs */

const en_pc_alt_faq_a1 = /** @type {(inputs: Pc_Alt_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For reading, commenting, filling forms, organizing pages and combining or splitting files, yes. It cannot yet edit existing text reliably, convert Office files or run e-signature workflows, which is where Acrobat is still ahead.`)
};

const zh_pc_alt_faq_a1 = /** @type {(inputs: Pc_Alt_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在阅读、批注、填写表单、整理页面以及合并或拆分文件方面，是的。它目前还不能可靠地编辑已有文字、转换 Office 文件或发起电子签名流程，这些方面 Acrobat 仍然领先。`)
};

/**
* | output |
* | --- |
* | "For reading, commenting, filling forms, organizing pages and combining or splitting files, yes. It cannot yet edit existing text reliably, convert Office fil..." |
*
* @param {Pc_Alt_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_a1 = /** @type {((inputs?: Pc_Alt_Faq_A1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_A1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_a1(inputs)
	return zh_pc_alt_faq_a1(inputs)
});
export { pc_alt_faq_a1 as "pc.alt.faq.a1" }